// extracted by mini-css-extract-plugin
module.exports = {"DiscoverMoreButton":"styles_DiscoverMoreButton__3i5Jh","DiscoverMore":"styles_DiscoverMore__1DyJS"};